

export type ApiResponseType ={
    isSuccess: boolean,
    data: any,
    errorMessage: string
} 
type successType ={
    result: any,
     passControl?:boolean
}
type errorType ={
    errorMsg: any, 
}
const apiHelper = {

    apiSuccess({ result, passControl }: successType):ApiResponseType {

        if (passControl) {
            return ({
                isSuccess: true,
                data: result.data,
                errorMessage: ""
            });
        }

        var data = result.data; 
        if (data?.isSuccess) {
            return ({
                isSuccess: true,
                data: data.data,
                errorMessage: ""
            });
        } if (result.status == 200) {
            return ({
                isSuccess: true,
                data: data,
                errorMessage: ""
            });
        } else {
            return ({
                isSuccess: false,
                errorMessage: data?.message,
                data: null
            });
        }
   
    },
    apiError({ errorMsg }: errorType) :ApiResponseType{
        
        let errorMessage = errorMsg;
        if (typeof errorMsg === 'object' && 
        errorMsg !== null) {
            errorMessage = errorMsg.Message || errorMsg.errorMessage;
        }
        return ({
            isSuccess: false,
            errorMessage: errorMessage,
            data: null
        });
    },
    objToQueryString({obj}: any) {
        const keyValuePairs = [];
        for (const key in obj) {

            keyValuePairs.push((key) + '=' + (obj[key]));
        }
        return keyValuePairs.join('&');
    },
}

export default apiHelper;